/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is it safe to publish Lorem Ipsum on a live site?`)
};

const es_li_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es seguro publicar Lorem Ipsum en un sitio en vivo?`)
};

const de_li_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist es sicher, Lorem Ipsum auf einer Live-Website zu veröffentlichen?`)
};

const nl_li_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is het veilig om Lorem Ipsum op een live website te publiceren?`)
};

const fr_li_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est-il sûr de publier Lorem Ipsum sur un site en direct ?`)
};

const it_li_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È sicuro pubblicare Lorem Ipsum su un sito dal vivo?`)
};

const pt_br2_li_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É seguro publicar Lorem Ipsum em um site ao vivo?`)
};

const pt_li_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É seguro publicar Lorem Ipsum em um site ao vivo?`)
};

const ja_li_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブサイトにLorem Ipsumを公開するのは安全ですか？`)
};

const zh_li_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在正式上线的网站上发布Lorem Ipsum安全吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_faq4_q", locale)
	if (locale === "en") return en_li_faq4_q(inputs)
	if (locale === "es") return es_li_faq4_q(inputs)
	if (locale === "de") return de_li_faq4_q(inputs)
	if (locale === "nl") return nl_li_faq4_q(inputs)
	if (locale === "fr") return fr_li_faq4_q(inputs)
	if (locale === "it") return it_li_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_li_faq4_q(inputs)
	if (locale === "pt") return pt_li_faq4_q(inputs)
	if (locale === "ja") return ja_li_faq4_q(inputs)
	return zh_li_faq4_q(inputs)
};